import React from 'react';

interface CharacterLimitedTextareaProps {
  rows?: number;
  maxLength?: number;
  name?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  value?: string;
}

export const CharacterLimitedTextarea: React.FC<
  CharacterLimitedTextareaProps & React.TextareaHTMLAttributes<HTMLTextAreaElement>
> = ({ rows = 4, maxLength = 150, name, onChange, value = '', ...props }) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => onChange?.(e);

  return (
    <div className="position-relative">
      <textarea
        rows={rows}
        maxLength={maxLength}
        name={name}
        value={value}
        onChange={handleChange}
        className="w-100 p-3 border rounded"
        {...props}
      />
      <div className="position-absolute" style={{ top: '-25px', right: '0' }}>
        {value.length} / {maxLength} characters
      </div>
    </div>
  );
};
